"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _avlComponents = require("@availabs/avl-components");

var _Border = _interopRequireDefault(require("./components/Border"));

var _amsUserSearch = _interopRequireDefault(require("../wrappers/ams-user-search"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var UserInProjectHeader = function UserInProjectHeader() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-15 py-1 gap-3 font-bold"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-5 border-b-2"
  }, "User Email"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-4 text-center border-b-2"
  }, "Add to Group"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-4 text-center border-b-2"
  }, "Remove from Group"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-2 text-center border-b-2"
  }, "Delete User"));
};

var UserInProject = function UserInProject(_ref) {
  var user = _ref.user,
      groups = _ref.groups,
      assignToGroup = _ref.assignToGroup,
      removeFromGroup = _ref.removeFromGroup,
      deleteUser = _ref.deleteUser,
      props = _objectWithoutProperties(_ref, ["user", "groups", "assignToGroup", "removeFromGroup", "deleteUser"]);

  var _React$useState = _react["default"].useState(""),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      addTo = _React$useState2[0],
      setAddTo = _React$useState2[1],
      _React$useState3 = _react["default"].useState(""),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      removeFrom = _React$useState4[0],
      setRemoveFrom = _React$useState4[1];

  groups.sort(function (a, b) {
    if (a.authLevel === b.authLevel) {
      return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
    }

    return a.authLevel - b.authLevel;
  });

  var _groups$reduce = groups.reduce(function (_ref2, c) {
    var _ref3 = _slicedToArray(_ref2, 2),
        a1 = _ref3[0],
        a2 = _ref3[1];

    if (user.groups.includes(c.name)) {
      a1.push(c);
    } else {
      a2.push(c);
    }

    return [a1, a2];
  }, [[], []]),
      _groups$reduce2 = _slicedToArray(_groups$reduce, 2),
      userGroups = _groups$reduce2[0],
      otherGroups = _groups$reduce2[1];

  var assign = _react["default"].useCallback(function (e) {
    assignToGroup(user.email, addTo.name);
    setAddTo("");
  }, [assignToGroup, user, addTo]);

  var remove = _react["default"].useCallback(function (e) {
    removeFromGroup(user.email, removeFrom.name);
    setRemoveFrom("");
  }, [removeFromGroup, user, removeFrom]);

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-15 py-1 gap-3"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-5 whitespace-nowrap overflow-hidden flex items-center"
  }, user.email), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-4"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-12 gap-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-8"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Select, {
    multi: false,
    placeholder: "Select a group...",
    options: otherGroups,
    accessor: function accessor(g) {
      return g.name;
    },
    listAccessor: function listAccessor(g) {
      return "".concat(g.name, " (auth level ").concat(g.authLevel, ")");
    },
    value: addTo,
    onChange: setAddTo
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-4"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    block: true,
    disabled: !addTo,
    onClick: assign
  }, "add")))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-4"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-12 gap-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-8"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Select, {
    multi: false,
    placeholder: "Select a group...",
    options: userGroups,
    accessor: function accessor(g) {
      return g.name;
    },
    value: removeFrom,
    onChange: setRemoveFrom
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-4"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    block: true,
    disabled: !removeFrom,
    onClick: remove
  }, "remove")))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-2 flex justify-center"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    buttonTheme: "buttonDanger",
    showConfirm: true,
    onClick: function onClick(e) {
      return deleteUser(user.email);
    }
  }, "delete")));
};

var _default = (0, _amsUserSearch["default"])(function (_ref4) {
  var search = _ref4.search,
      setSearch = _ref4.setSearch,
      adjustAmount = _ref4.adjustAmount,
      matches = _ref4.matches,
      remaining = _ref4.remaining,
      props = _objectWithoutProperties(_ref4, ["search", "setSearch", "adjustAmount", "matches", "remaining"]);

  return /*#__PURE__*/_react["default"].createElement(_Border["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-2 gap-x-3 gap-y-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-1"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Input, {
    placeholder: "Search for a user...",
    showClear: true,
    value: search,
    onChange: setSearch
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-1"
  }, !search ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-center"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    className: "mx-1",
    disabled: matches.length <= 5,
    onClick: function onClick(e) {
      return adjustAmount(-5);
    }
  }, "Show Less"), /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    className: "mx-1",
    disabled: !remaining,
    onClick: function onClick(e) {
      return adjustAmount(5);
    }
  }, "Show More"))), !search ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-2"
  }, /*#__PURE__*/_react["default"].createElement(UserInProjectHeader, null), matches.map(function (user) {
    return /*#__PURE__*/_react["default"].createElement(UserInProject, _extends({
      key: user.email
    }, props, {
      user: user
    }));
  }))), !(search && remaining) ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-1"
  }, "Plus ", remaining, " others..."));
});

exports["default"] = _default;